module.exports = __webpack_public_path__ + "img/07.8ea99722.png";